import { useEffect, useRef } from "react";

export const useFilePolling = (open, file, refetch) => {
  const pollingRef = useRef(null);
  const pollCountRef = useRef(0);
  const refetchRef = useRef(refetch);

  // Always keep the latest refetch function
  useEffect(() => {
    refetchRef.current = refetch;
  }, [refetch]);

  useEffect(() => {
    if (
      !open ||
      !file ||
      file.isFileValid !== null ||
      pollCountRef.current >= 5
    ) {
      return;
    }

    if (!pollingRef.current) {
      pollingRef.current = setInterval(() => {
        pollCountRef.current += 1;
        refetchRef.current();

        if (pollCountRef.current >= 5) {
          clearInterval(pollingRef.current);
          pollingRef.current = null;
        }
      }, 5000);
    }

    return () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
      pollCountRef.current = 0;
    };
  }, [open, file?.isFileValid]);
};
